import React, { Component } from "react";
import { Grid, Col, Row, Form, FormGroup, ControlLabel, FormControl, Button, Image } from "react-bootstrap";
import GoogleMapsLoader from "google-maps";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";
import Functions from "../../../src/util/functions";
import linkedin from '../../assets/images/icons/linkedin_icon.svg';

GoogleMapsLoader.KEY = "AIzaSyCq1CXQbDuMtg1LajNE_1au1W_R3bLScLk";

const dropdownOptions = [
    "Utility membership",
    "Corporate membership",
    "Event sponsorship",
    "General"
];

export default class ContactUs extends Component {
    componentDidMount() {
        GoogleMapsLoader.load((google) => {
            const gwi = {lat: 51.7500365, lng: -1.2670036};
            const map = new google.maps.Map(document.getElementById("map"), {
                zoom: 4,
                minZoom: 2,
                center: {lat: gwi.lat, lng: gwi.lng + 2}
            });
            const marker = new google.maps.Marker({
                position: gwi,
                map: map,
                title: "Global Water Leaders Group"
            });
            const contentString = `
                <div className="info-window">
                    <strong>Global Water Leaders Group</strong><br />
                    Kingsmead House<br />
                    Oxpens Road<br />
                    Oxford<br />
                    OX1 1XX<br />
                    United Kingdom
                </div>
            `;
            const infoWindow = new google.maps.InfoWindow({
                content: contentString
            });
            infoWindow.open(map, marker);
            marker.addListener("click", function() {
                infoWindow.open(map, marker);
            });
        });
    }

    render() {
        const user = this.props.currentUser;

        if (user) {
            dropdownOptions.unshift("Amend utility details");
        }
        const options = dropdownOptions.map((option, i) => {
            return <option value={option} key={`option${i + 1}`}>{option}</option>;
        });

        let nameAndEmailInput;
        if (user) {
            nameAndEmailInput = (
                <div>
                    <FormGroup controlId="formHorizontalName">
                        <FormControl type="text" placeholder="Name" name="name" value={`${user.first_name} ${user.last_name}`} required readOnly />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalEmail">
                        <FormControl type="email" placeholder="E-mail" name="email" value={user.email} required readOnly />
                    </FormGroup>
                </div>
            );
        } else {
            nameAndEmailInput = (
                <div>
                    <FormGroup controlId="formHorizontalName">
                        <FormControl type="text" placeholder="Name" name="name" required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalEmail">
                        <FormControl type="email" placeholder="E-mail" name="email" required />
                    </FormGroup>
                </div>
            );
        }

        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background contact-us">
                    <Banner heading="Contact Us" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <Row>
                        <Col md={5}>
                            <Form method="POST">
                                <FormControl type="hidden" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                                {nameAndEmailInput}

                                <FormGroup controlId="formHorizontalTopic">
                                    <FormControl componentClass="select" name="topic" defaultValue="">
                                        <option value="" disabled hidden>Nature of enquiry</option>
                                        {options}
                                    </FormControl>
                                </FormGroup>

                                <FormGroup controlId="formHorizontalSubject">
                                    <FormControl type="text" placeholder="Subject" name="subject" required />
                                </FormGroup>

                                <FormGroup controlId="formMessage">
                                    <FormControl componentClass="textarea" placeholder="Please enter your message..." name="message" required />
                                </FormGroup>

                                <FormGroup>
                                    <Button type="submit">Send</Button>
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={7}>
                            <Row className="contact-details">
                                <Col md={12}>
                                    <p>
                                        For general enquiries, including enquiries to the Advisory Board, you may contact Leading Utilities of the World team members: Ana Budimir at <a href="mailto:a.budimir@leadingutilities.org">a.budimir@leadingutilities.org</a>.
                                    </p>

                                    <p>
                                        For enquiries regarding corporate membership or event sponsorship, you may contact Abigail Edward of the Leading Utilities of the World team at <a href="mailto:abigail.edwards@leadingutilities.org">abigail.edwards@leadingutilities.com</a>.
                                    </p>
                                    <p>
                                        <a
                                            href="https://www.linkedin.com/showcase/leading-utilities-of-the-world"
                                            target="_blank"
                                            className="social-icon-wrapper"
                                        >
                                            <Image src={linkedin} className="social-icon" alt="Follow us on linkedin" />&nbsp;Follow us on LinkedIn
                                        </a>
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div id="map"></div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/ContactUs.jsx.erb